import { FC, ReactNode } from 'react';
import { KalenderhändelsearkivResponse } from '../types/pages';
import KompaktKalender from '../components/Kalender/KompaktKalender';
import Kalender from '../components/Kalender/Kalender';
import { ContentResponse } from '../types/shared';

interface IKalenderhändelseBlock {
  contentResponse: ContentResponse;
}

const KalenderhändelseBlock: FC<IKalenderhändelseBlock> = ({ contentResponse }): ReactNode => {
  const kalenderhändelsearkivResponse = contentResponse.content as KalenderhändelsearkivResponse;
  return (kalenderhändelsearkivResponse.visaKompakt
    ? <KompaktKalender response={kalenderhändelsearkivResponse}></KompaktKalender>
    : <Kalender response={kalenderhändelsearkivResponse}></Kalender>
  );
};

export default KalenderhändelseBlock;
